import { ImageSize } from '@/interfaces/imageSize';
import { AVATAR_SIZE, MEDIA_URL } from '@/utils/constants';

/**
 * Zwraca link do pobrania obrazka w wymiarach avataru
 *
 * @export
 * @param {number} id
 * @returns {string}
 */
export function avatarUrl(id: number): string {
  return mediaUrl(id, AVATAR_SIZE);
}

/**
 * Zwraca link do pobrania pliku
 *
 * @export
 * @param {number} id
 * @returns {string}
 */
export function mediaUrl(id: number, size?: ImageSize): string {
  const url = `${MEDIA_URL}/${id}`;
  if (size) {
    return url + `?${sizeString(size)}`;
  }
  return url;
}

/**
 * Query string rozmiarów
 *
 * @param {ImageSize} size
 * @returns {string}
 */
function sizeString(size: ImageSize): string {
  const sizes = [];
  if (size.width) {
    sizes.push(`width=${size.width}`);
  }
  if (size.height) {
    sizes.push(`height=${size.height}`);
  }
  return sizes.join('&');
}
